import { Flex, Text } from '@chakra-ui/layout'
import { useState, useEffect } from 'react'
import { FaTrash } from 'react-icons/fa'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../../components/InputCmp'
import { UpdateElementByPosition } from '../../../../../../Utils/Helper'
import { ModalBody, ModalContent, ModalFooter } from './styles'

Modal.setAppElement('#root')

interface IProps {
  isOpen: boolean
  cores: string[]
  onRequestClose: () => void
  onUpdate: (cores: string[]) => void
}

export const ModalCores: React.FC<IProps> = ({
  isOpen,
  cores,
  onRequestClose,
  onUpdate
}) => {
  const [Cores, setCores] = useState<string[]>([])

  useEffect(() => {
    setCores(cores.length === 0 ? [''] : cores)
  }, [cores])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <ModalContent>
        <h3>Editar cores por nível no organograma</h3>
        <ModalBody style={{ marginTop: '.75rem', display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1rem' }}>
          {Cores.map((e, i) => {
            return <Flex gap={'1rem'} alignItems='center'>
              <Text fontSize={'14px'} fontWeight={'700'} w={'3.5rem'}>Nível {i + 1}: </Text>
              <InputCmp type={'color'} value={e} OnChange={(val) => setCores(UpdateElementByPosition(Cores, i, val))}/>
              <ButtonCmp VarColor='Red' onClick={() => setCores(Cores.filter(a => a !== e))}><FaTrash/></ButtonCmp>
            </Flex>
          })}
          <Flex>
            <ButtonCmp onClick={() => setCores([...Cores, '#000000'])} VarColor='Rosa'>Adicionar</ButtonCmp>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <ButtonCmp VarColor='c6' onClick={onRequestClose}>Fechar</ButtonCmp>
          <ButtonCmp VarColor='Green2' onClick={() => onUpdate(Cores)} >Salvar</ButtonCmp>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
